import * as ScrollMagic from "scrollmagic"
import { TweenMax, TimelineMax } from "gsap"
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap"

// Это нпм версия animation.gsap
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax)

export default function initPortfolioAnimations() {
    const allSlides = Array.from(document.querySelectorAll(".portfolio__slide"))

    if (allSlides.length === 0) return

    const slidesLength = allSlides.length

    // Create Bullets
    const bulletsContainer = document.querySelector(".portfolio__pagination")
    // remove old bullets
    while (bulletsContainer.firstChild) {
        bulletsContainer.firstChild.remove()
    }

    allSlides.forEach((slide, index) => {
        slide.setAttribute("data-bullet", index)

        let isActive
        index === 0 ? (isActive = "active") : (isActive = "")
        bulletsContainer.insertAdjacentHTML(
            "beforeend",
            `<span class="bullet bullet-${index} ${isActive}">
                <span></span>
            </span>
            `,
        )
    })

    // Create fraction
    const fractionAll = document.querySelector(".portfolio__pagination-fraction .all")
    const fractionCur = document.querySelector(".portfolio__pagination-fraction .cur")

    fractionAll.innerHTML = updateFormat(slidesLength)
    fractionCur.innerHTML = "01"

    // helpers
    function updateFormat(num) {
        num = +num
        return num >= 10 ? num : "0" + num.toString()
    }

    function updateCurrentBullet(bullet) {
        Array.from(bulletsContainer.children).forEach((child) => child.classList.remove("active"))
        bulletsContainer.children[bullet].classList.add("active")
    }

    function updateCurrentFraction(bullet) {
        fractionCur.innerHTML = updateFormat(+bullet + 1)
    }

    // OBSERVER=========================================================

    const config = {
        rootMargin: "0px",
        threshold: 1.0,
    }

    const observerCallback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                updateCurrentBullet(entry.target.getAttribute("data-bullet"))
                updateCurrentFraction(entry.target.getAttribute("data-bullet"))
            }
        })
    }
    const slidesObserver = new IntersectionObserver(observerCallback, config)

    allSlides.forEach((target) => {
        slidesObserver.observe(target)
    })
    //
    // // ANIMATIONS=======================================================================
    // const innerHeight = window.innerHeight
    //
    // const smController = new ScrollMagic.Controller({
    //     refreshInterval: 0,
    // })
    //
    // allSlides.forEach((slide, index) => {
    //     if (window.matchMedia("(max-width: 767px)").matches) {
    //         new ScrollMagic.Scene({
    //             triggerElement: slide,
    //             duration: slide.offsetHeight + 300,
    //             offset: -70,
    //         })
    //             .setTween(new TimelineMax().fromTo(slide.querySelector(".portfolio__slide-info"), 1, { y: 70 }, { y: -20 }, 0).fromTo(slide.querySelector(".portfolio__slide-img"), 1, { y: 35 }, { y: 0 }, 0))
    //             .addTo(smController)
    //     } else {
    //         if (index !== 0) {
    //             new ScrollMagic.Scene({
    //                 triggerElement: slide,
    //                 duration: slide.offsetHeight,
    //                 offset: -200,
    //             })
    //                 .setTween(new TimelineMax().fromTo(slide.querySelector(".portfolio__slide-info"), 1, { y: 250 }, { y: -100 }, 0).fromTo(slide.querySelector(".portfolio__slide-img"), 1, { y: 150 }, { y: 0 }, 0))
    //                 .addTo(smController)
    //         }
    //     }
    // })
}
